// eslint-disable-next-line no-restricted-imports -- moved as-is from classic; behavior-preserving migration
import window from 'window-or-global';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

export function bind(
	eventType: string,
	eventData?: unknown,
	handler?: (...args: unknown[]) => unknown,
): unknown {
	if (typeof handler === 'function') {
		return $(window).bind(eventType, eventData, handler);
	} else {
		return $(window).bind(eventType, eventData as any);
	}
}

export function unbind(eventType: string, handler?: (...args: unknown[]) => unknown): unknown {
	return $(window).unbind(eventType, handler as any);
}

export function trigger(eventType: string, extraParameters?: unknown): unknown {
	return $(window).trigger(eventType, extraParameters as any);
}
